import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule, NgbPaginationModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxBootstrapTreeviewModule } from 'ngx-bootstrap-treeview';

const MODULES = [
  CommonModule,
  NgbPaginationModule,
  NgbModule, 
  NgOptionHighlightModule,
  NgSelectModule,
  NgxBootstrapTreeviewModule,
  NgbDatepickerModule
];

@NgModule({
  declarations: [],
  imports: [
    MODULES
  ],
  exports: [MODULES]
})
export class BootstrapModule { }
